import * as React from "react";
const SvgNoInternet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M6.5 20q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475Q3.349 9.575 5.25 9.15q.625-2.3 2.5-3.725T12 4q2.925 0 4.962 2.037T19 11q1.725.2 2.863 1.488A4.4 4.4 0 0 1 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20zm0-2h12q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-2.075-1.463-3.537Q14.075 6 12 6 9.925 6 8.463 7.463 7 8.925 7 11h-.5q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 3 14.5q0 1.45 1.025 2.475A3.37 3.37 0 0 0 6.5 18m5.5-2q.424 0 .713-.287A.97.97 0 0 0 13 15a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 14a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 15q0 .424.287.713.288.287.713.287m0-3.5q.424 0 .713-.287A.97.97 0 0 0 13 11.5V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 9v2.5q0 .424.287.713.288.287.713.287"
    />
  </svg>
);
export default SvgNoInternet;
